import { Injectable, inject } from '@angular/core';
import { MabArticlesService } from '@app/platform/articles/pages/mab-articles/services/mab-articles.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs/internal/observable/of';
import { catchError, distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';
import { selectIsClientUserMABLandlord } from '../common.selectors';
import { getArticlesAction, getArticlesActionFailure, getArticlesActionSuccess } from './articles.actions';

@Injectable()
export class ArticlesEffects {
  private readonly articlesService = inject(MabArticlesService);
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store);

  getArticlesEffect = createEffect(() =>
    this.actions$.pipe(
      ofType(getArticlesAction),
      switchMap(() => this.articlesService.getArticles()),
      map((articles) => getArticlesActionSuccess({ data: articles })),
      catchError((error) => of(getArticlesActionFailure({ error }))),
    ),
  );

  triggerArticlesOnMabLandlordStatus$ = createEffect(() =>
    this.store.select(selectIsClientUserMABLandlord).pipe(
      distinctUntilChanged(),
      filter((isMabLandlord) => isMabLandlord === true),
      map(() => getArticlesAction()),
    ),
  );
}
